'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _ListElement = require('../../list/ListElement');

var _ListElement2 = _interopRequireDefault(_ListElement);

var _InboxHeader = require('../../inbox/InboxHeader');

var _InboxHeader2 = _interopRequireDefault(_InboxHeader);

var _PageLoaderMain = require('../../components/loaders/PageLoaderMain');

var _PageLoaderMain2 = _interopRequireDefault(_PageLoaderMain);

require('./Document.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var Document = function Document(props) {
    var orderedElements = props.orderedElements,
        inboxElements = props.inboxElements,
        currentBoardId = props.currentBoardId,
        gridSize = props.gridSize,
        elementFilter = props.elementFilter,
        isEditable = props.isEditable,
        isCurrentBoardFetching = props.isCurrentBoardFetching,
        isCurrentBoardFetched = props.isCurrentBoardFetched;


    if (isCurrentBoardFetching && !isCurrentBoardFetched) return _react2.default.createElement(_PageLoaderMain2.default, null);

    return _react2.default.createElement(
        'div',
        { className: 'Document' },
        orderedElements.map(function (element) {
            return _react2.default.createElement(_ListElement2.default, {
                element: element,
                key: element.get('id'),
                currentBoardId: currentBoardId,
                inList: 'in-list-document-mode',
                inListClass: 'in-list-document-mode',
                gridSize: gridSize,
                elementFilter: elementFilter,
                isEditable: isEditable,
                documentMode: true });
        }),
        inboxElements.size ? _react2.default.createElement(_InboxHeader2.default, null) : null,
        inboxElements.map(function (element) {
            return _react2.default.createElement(_ListElement2.default, {
                element: element,
                key: element.get('id'),
                currentBoardId: currentBoardId,
                inList: 'in-list-document-mode',
                gridSize: gridSize,
                elementFilter: elementFilter,
                isEditable: isEditable,
                documentMode: true });
        })
    );
};

// Styles
// Lib


Document.propTypes = {
    orderedElements: _propTypes2.default.object,
    inboxElements: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string.isRequired,
    gridSize: _propTypes2.default.number,
    elementFilter: _propTypes2.default.object,
    isEditable: _propTypes2.default.bool,
    isCurrentBoardFetching: _propTypes2.default.bool,
    isCurrentBoardFetched: _propTypes2.default.bool
};

exports.default = (0, _recompose.pure)(Document);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/Document.js
// module id = 2200
// module chunks = 0